<app-sub-navbar></app-sub-navbar>

<!-- Content -->

<section class="container-fluid my-md-4 bd-layout">
  <aside class="bd-sidebar">
    <nav class="collapse bd-links" id="filterz" aria-label="filterz">
      <ul class="list-unstyled mb-0 py-3 pt-md-1">
        <li class="mb-1">
          <a
            routerLink="/profile"
            class="btn d-inline-flex align-items-center rounded"
          >
            Profile
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/downloads"
            class="btn d-inline-flex align-items-center rounded"
          >
            Downloads
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/favorites"
            class="btn d-inline-flex align-items-center rounded"
          >
            Favorites
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/subscription"
            class="btn d-inline-flex align-items-center rounded"
          >
            Subscription
          </a>
        </li>
      </ul>
    </nav>
  </aside>

  <div class="container overflow-hidden">
    <div class="row">
      <div class="pad-bottom justify-content-between d-flex">
        <h3 class="fw-bold">Favorites</h3>

        <button
          class="btn bd-sidebar-toggle d-md-none py-0 px-1 ms-3 order-3 collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#filterz"
          aria-controls="filterz"
          aria-expanded="false"
          aria-label="Toggle docs navigation"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            class="bi bi-expand"
            viewBox="0 0 16 16"
          >
            <title>Expand</title>
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z"
            />
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            class="bi bi-collapse"
            viewBox="0 0 16 16"
          >
            <title>Collapse</title>
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707l-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z"
            />
          </svg>
        </button>
      </div>

      <!-- user?.favorites -->
      <div class="masonry-container mb-4" #masonryContainer>
        <div class="masonry-item" *ngFor="let data of visibleIllusData; let i = index">
          <figure class="showcase">
            <div class="badge-wrap" *ngIf="data.isPremium && data.imageLoad">
              <span class="badge rounded cursor text-bg-dark">Pro</span>
            </div>
            <!-- Skeleton (auto visible before image load) -->
            <div class="skeleton" *ngIf="!data.imageLoad"></div>
            <a
              *ngIf="getSEOImage(data?.previewUrl || data.jpeg || data.png)"
              [routerLink]="
                !data.isAIIllustration
                  ? '/illustration/' + data.slug
                  : '/ai-image/' + data.slug
              "
            >
            <!-- data?.previewUrl || data.jpeg || data.png  -->
              <img
                [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)"
                [alt]="data.title"
                class="img-radius img-fluid"
                (load)="onImageLoad(i, $event)"
                 loading="lazy"
              />

              <figcaption class="hide-caption figure-caption">
                <p>{{ data.title }}</p>
              </figcaption>
            </a>
          </figure>
        </div>
         <!-- *ngIf="!user || user?.favorites?.length === 0" -->
        <div
          class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
         *ngIf="!loader && visibleIllusData.length === 0"
        >
         <div class="container">
                <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg"
                  alt="No Data Found" />
                <h1 class="fw-bold fs-4 text-dark mb-2">
                 You haven’t added any favourites yet
                </h1>
                <p class="mb-4 text-dark">
                 Add items to your favourites to find them quickly later.
                </p>
              </div>
        </div>
      </div>
      

        <!-- 🔹 Load More Row (SEPARATE ROW) -->
          <div class="row my-4" *ngIf="!loader && hasMoreIllus">
            <div class="col-12 d-flex justify-content-center">

              <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMoreIllus()" [disabled]="isLoadingMore">

                <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm"></span>

                <span>{{ isLoadingMore ? 'Loading...' : 'Load more' }}</span>

              </button>

            </div>
          </div>
        
    </div>
  </div>
</section>
